// extracted by mini-css-extract-plugin
module.exports = {"ReviewContents":"_1k1NrVIGY7_0HD_i5M9ieV"};